import React from 'react';
import { motion } from "framer-motion";
import Bg from '../../Assets/images/saveS.png';
import Bgs from '../../Assets/images/saveB.png';
import Star from '../../Assets/images/star.svg';
import Constant from '../../Constant';
import I1 from '../../Assets/images/si1.svg';
import I2 from '../../Assets/images/si2.png';
import I3 from '../../Assets/images/si3.png';
import Tcom from './Tcom';
import Button from '../SelectValue/Button';

function TopSec() {
  return (
    <div className="relative overflow-hidden body-bg ">
      <div className="pt-[140px] sm:pt-[177px] grid sm:grid-cols-3 gap-4">
        <div className="md:col-span-2 mb-10 px-6 sm:px-24">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <p className="inline-block bg-white p-3 text-[12px] font-[500] rounded-[32px] text-primary-color mb-4">
              <img src={Star} alt="Star" className="inline" /> Empowering Ethics, Enriching Futures.
            </p>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-[24px] mb-6 font-[24px] text-text-color1 sm:text-[48px]"
          >
            Save Smart.{" "}
            <span className={Constant.linearColor}>Save Halal.</span> Save Together.
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="text-[14px] mb-10 font-[500] text-text-color1 sm:text-[20px]"
          >
            Build your savings ethically – with collaborative group goals, AI guidance, and full Shariah compliance.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
          >
            <div className="flex flex-col sm:flex-row gap-4">
              <Button name="Start Saving" />
              <Button name="Explore Savings Pods" />
            </div>
          </motion.div>
        </div>

        <div className="relative px-10 sm:pt-20">
          <motion.img
            src={Bg}
            alt="home"
            className="hidden md:block w-full h-auto"
            initial={{ opacity: 0, x: 100 }}
            animate={{
              opacity: 1,
              x: 0,
              y: [0], 
            }}
            transition={{
              opacity: { duration: 1, ease: "easeOut" },
              x: { duration: 1, ease: "easeOut" },
              y: { duration: 3, repeat: Infinity, ease: "easeInOut" },
            }}
          />

          <motion.img
            src={Bgs}
            alt="home"
            className="md:hidden block w-full h-auto"
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
          />

          <motion.div
            className="absolute top-0 left-16 sm:top-20 sm:left-20"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 1 }}
          >
            <Tcom img={I1} con="Eid savings" />
          </motion.div>

          <motion.div
            className="absolute top-0 sm:top-48 right-5"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 1.2 }}
          >
            <Tcom img={I2} con="Nikkah savings" />
          </motion.div>

          <motion.div
            className="absolute bottom-2 right-4 sm:left-16"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 1.4 }}
          >
            <Tcom img={I3} con="Travel savings" />
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default TopSec;
